import PropTypes from 'prop-types'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Select from 'react-select'

import { getReactSelectTheme } from '../../booking-form-react/components/airport-picker'
import FileInput from '../inputFile'
import ChoiceList from './choice-list'
import ChoiceOption from './choice-option'

const booleanOptions = [
  {
    value: 'true',
    label: 'Yes',
  },
  {
    value: 'false',
    label: 'No',
  },
]

const prepareOptions = (options = []) =>
  options.map(({ body }) => ({ label: body, value: body }))

const OpenQuestion = props => {
  const {
    hasError,
    id,
    kind,
    required = false,
    body,
    name = `questions[${id}]`,
  } = props
  const { register, control } = useFormContext()

  let questionContents = null

  switch (kind) {
    case 'boolean':
      questionContents = (
        <ChoiceList
          options={booleanOptions}
          name={name}
          hasError={hasError}
          required={required}
        />
      )
      break
    case 'single_choice':
      questionContents = (
        <Controller
          control={control}
          name={name}
          {...register(name, {
            required,
          })}
          render={({ field }) => (
            <Select
              options={prepareOptions(props.open_question_options)}
              className={hasError ? 'invalid' : ''}
              classNames={{
                control: () => 'contact-form__input',
              }}
              classNamePrefix='styled-select'
              theme={getReactSelectTheme}
              {...field}
            />
          )}
        />
      )
      break
    case 'multi_choice':
      questionContents = (
        <Controller
          control={control}
          name={name}
          {...register(name, {
            required,
          })}
          render={({ field }) => (
            <Select
              isMulti
              options={prepareOptions(props.open_question_options)}
              className={hasError ? 'invalid' : ''}
              classNames={{
                control: () => 'contact-form__input',
              }}
              classNamePrefix='styled-select'
              theme={getReactSelectTheme}
              {...field}
            />
          )}
        />
      )
      break
    case 'infobox':
      return (
        <div className='pt-48 mb-48'>
          <p
            className='warning-box'
            dangerouslySetInnerHTML={{ __html: body }}
          ></p>
        </div>
      )
    case 'legal':
      return (
        <div>
          <ChoiceOption
            name={name}
            required={required}
            value='true'
            hasError={hasError}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: body,
              }}
            ></span>
          </ChoiceOption>
        </div>
      )
    case 'file':
      return (
        <FileInput
          errors={hasError}
          label={`${body}${required ? ' *' : ''}`}
          {...register(name, {
            required,
          })}
        />
      )
    case 'string':
      questionContents = (
        <input
          className='input-field contact-form__input'
          {...register(name, {
            required,
          })}
        />
      )
      break
    default:
      questionContents = (
        <textarea
          rows={4}
          cols={4}
          maxLength={2000}
          className='input-field contact-form__input'
          {...register(name, {
            required,
          })}
        />
      )
  }

  return (
    <label
      className={`input-block contact-form__block mb-24 small-8 cell ${
        hasError ? 'invalid' : ''
      }`}
    >
      <span className='contact-form__label mb-8'>
        {body} {required && <sup>*</sup>}
      </span>
      {questionContents}
    </label>
  )
}

OpenQuestion.propTypes = {
  translations: PropTypes.shape({
    en: PropTypes.shape({
      body: PropTypes.string,
    }),
  }),
  hasError: PropTypes.bool,
  id: PropTypes.number,
  kind: PropTypes.string,
  required: PropTypes.bool,
  open_question_options: PropTypes.array,
  body: PropTypes.string,
  name: PropTypes.string,
}

export default OpenQuestion
